import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import { HOTLINE } from "@/lib/api";
import { Logo } from "./Navbar";

export function Footer() {
  return (
    <footer className="navy text-slate-300 mt-24 relative grain overflow-hidden" data-testid="footer">
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 space-y-5">
          <Logo dark />
          <p className="max-w-md text-sm leading-relaxed">Apnicare connects patients across India with trusted hospitals, clinics, doctors and affordable diagnostic labs. Built for care, only for our people.</p>
          <div className="flex flex-wrap gap-3">
            <a href={`tel:${HOTLINE}`} className="inline-flex items-center gap-2 rounded-full bg-white text-[#06152D] px-4 py-2 text-sm font-semibold hover:bg-sky-100 transition-colors" data-testid="footer-call-button"><Phone size={15} /> Call {HOTLINE}</a>
            <a href={`https://wa.me/91${HOTLINE}`} target="_blank" rel="noreferrer" data-cursor="CHAT" className="inline-flex items-center gap-2 rounded-full glass px-4 py-2 text-sm font-semibold hover:bg-white/15 transition-colors" data-testid="footer-whatsapp-button"><MessageCircle size={15} /> WhatsApp</a>
          </div>
        </div>
        <div>
          <div className="eyebrow mb-4 !text-sky-300">Explore</div>
          <ul className="space-y-2.5 text-sm">
            {[["Find Hospitals", "/search"], ["HealthAI Assistant", "/healthai"], ["Health Insurance", "/insurance"], ["Diagnostic Lab", "/diagnostics"], ["Wellness Mart", "/wellness-mart"]].map(([l, to]) => <li key={to}><Link to={to} className="hover:text-white transition-colors">{l}</Link></li>)}
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4 !text-sky-300">For Providers</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/join-doctor" className="hover:text-white transition-colors">Join as a Doctor</Link></li>
            <li><Link to="/join-doctor" className="hover:text-white transition-colors">List your Hospital / Clinic</Link></li>
            <li><Link to="/login" className="hover:text-white transition-colors">Provider Login</Link></li>
          </ul>
          <div className="mt-6 flex items-start gap-2 text-xs text-slate-400"><MapPin size={14} className="mt-0.5" /> Serving New Delhi, Ghaziabad, Noida, Greater Noida & across NCR</div>
        </div>
      </div>
      <div className="relative border-t border-white/10 py-5 text-center text-xs text-slate-400 px-4">
        © {new Date().getFullYear()} Apnicare. Hospital details are compiled from public sources. In an emergency call 112 / 108.
      </div>
    </footer>
  );
}
